import { Button } from '@repo/ui/components/ui/button';
import { cn } from '@repo/ui/lib/utils';
import { useNavigate, useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';
import { ANALYTICS_EVENTS } from '@/lib/analytics/events';
import { track } from '@/lib/analytics/track';

type GeneralErrorProps = React.HTMLAttributes<HTMLDivElement> & {
    minimal?: boolean;
    error?: unknown;
};

export function GeneralError({ className, minimal = false, error }: GeneralErrorProps) {
    const navigate = useNavigate();
    const { history } = useRouter();

    useEffect(() => {
        const errorClass = error instanceof Error ? error.name : typeof error === 'object' && error !== null ? error.constructor.name : 'Unknown';
        track(ANALYTICS_EVENTS.ERROR_RENDERED, {
            component: 'GeneralError',
            error_class: errorClass,
        });
    }, [error]);

    return (
        <div className={cn('h-svh w-full', className)}>
            <div className='m-auto flex h-full w-full flex-col items-center justify-center gap-2'>
                {!minimal && <h1 className='font-bold text-[7rem] leading-tight'>500</h1>}
                <span className='font-medium'>Oops! Something went wrong {`:')`}</span>
                <p className='text-center text-muted-foreground'>
                    We apologize for the inconvenience. <br /> Please try again later.
                </p>
                {!minimal && (
                    <div className='mt-6 flex gap-4'>
                        <Button variant='outline' onClick={() => history.go(-1)}>
                            Go Back
                        </Button>
                        <Button onClick={() => navigate({ to: '/' })}>Back to Home</Button>
                    </div>
                )}
            </div>
        </div>
    );
}
